/**
 * Convenience helper that simplifies getting access to the current customer's state (customer ID and loading state)
 *
 * @param {Function} getProvider - provider "getter", typically supplied by "mapStateToProps" method
 * @returns {{customerId: *, isCustomerLoaded: (boolean)}} - Note that {customerId} may be `undefined`
 */
export function getCurrentCustomerState(getProvider) {
  const currentLocation = getProvider('currentLocation').get();
  const customersProvider = getProvider('customers');
  const customerId = currentLocation?.customerId;
  const isCustomerLoaded = !!customerId && customersProvider.has(customerId);

  return {
    customerId,
    isCustomerLoaded,
  };
}
